const LabelActionManager = {
    data () {
        return {
            labelToDelete: undefined,
            labelToEdit: undefined,
            showLabelPopover: false,
            disablePublicToggle: false,
        };
    },
    methods: {
        openDeleteModal (label) {
            this.labelToDelete = label;
        },
        onDeleteModalClose () {
            this.labelToDelete = undefined;
        },
        openEditModal (label) {
            this.labelToEdit = label;
            this.disablePublicToggle = true;
            this.showLabelPopover = true;
        },
        onLabelPopoverClose () {
            this.showLabelPopover = false;
            this.labelToEdit = undefined;
            this.disablePublicToggle = false;
        },
    },
};

export default LabelActionManager;
